import { React, useEffect, useState } from "react";
import CardDetails from "./CardDetails";
import totalUsers from "../../../images/totalUsers.png";
import SuccessfulRequest from "../../../images/SuccessfulRequest.svg";
import failedRequest from "../../../images/failedRequest.svg";
import anumati from "../../../images/anumati.png";
import SuccessfulRequestGraph from "../utils/SuccessfulRequestGraph";
import activeConsent from "../../../images/AG Dashboard/activeConsent.svg";
import expired from "../../../images/AG Dashboard/expired.png";
import recvokedConsent from "../../../images/AG Dashboard/revokedConsent.svg";
import cancel from "../../../images/AG Dashboard/cancel.png";
import orderHistory from "../../../images/AG Dashboard/order-history.png";
import SlideImageCard from "./SlideImageCard";
import AccountAggCard from "./AccountAggCard";
import oneMoney from "../../../images/AG Dashboard/oneMoneyLogo.png";
import finvu from "../../../images/AG Dashboard/finvu.png";
import nadl from "../../../images/AG Dashboard/nadl.png";
import cams from "../../../images/AG Dashboard/camsfinserv.png";
import protean from "../../../images/AG Dashboard/protean.png";
import axios from "axios";
import { formatString } from "../../../utils/handlers";
import ImageLoading from "../../../components/ImageLoading";

const AgSection = () => {
  const [Loading, setLoading] = useState(false);
  const [agSubsection, setAgSubsction] = useState("user");
  const [successGraph, setSuccessGraph] = useState({});
  const [failedGraph, setFailedGraph] = useState({});
  const [Statistics, setStatistics] = useState({});
  const [consentStatistics, setConsentStatistics] = useState({});
  const [summaryDetails, setSummaryDetails] = useState({});
  const dates = [];
  const failedDates = [];
  const successFetch = [];
  const failedFetch = [];

  const agFilter = [
    {
      name: "User",
      value: "user",
    },
    {
      name: "Consent",
      value: "consent",
    },
    {
      name: "Summary",
      value: "summary",
    },
  ];
  const fetchGraphDetails = async () => {
    setLoading(true);
    let url = "";
    const token = localStorage.getItem("token");
    try {
      url = `${process.env.REACT_APP_URL}/lender/v1/users/fetch_successful_fetch_data`;
      const options = {
        url: url,
        method: "GET",
        headers: { Authorization: token },
      };
      const res = await axios(options);
      setSuccessGraph(res.data.successful);
      setFailedGraph(res.data.failed);
    } catch (e) {
    } finally {
      setLoading(false);
    }
  };
  const fetchStatistics = async () => {
    setLoading(true);
    let url = "";
    const token = localStorage.getItem("token");
    try {
      url = `${process.env.REACT_APP_URL}/lender/v1/users/users_aggregators_statistics`;
      const options = {
        url: url,
        method: "GET",
        headers: { Authorization: token },
      };
      const res = await axios(options);
      setStatistics(res?.data?.statistics);
    } catch (e) {
    } finally {
      setLoading(false);
    }
  };
  const fetchConsentDetails = async () => {
    setLoading(true);
    let url = "";
    const token = localStorage.getItem("token");
    try {
      url = `${process.env.REACT_APP_URL}/lender/v1/users/consent_statistics`;
      const options = {
        url: url,
        method: "GET",
        headers: { Authorization: token },
      };
      const res = await axios(options);
      setConsentStatistics(res?.data?.data);
    } catch (e) {
    } finally {
      setLoading(false);
    }
  };
  const fetchSummaryDetails = async () => {
    setLoading(true);
    let url = "";
    const token = localStorage.getItem("token");
    try {
      url = `${process.env.REACT_APP_URL}/lender/v1/users/asset_gateway_summary`;
      const options = {
        url: url,
        method: "GET",
        headers: { Authorization: token },
      };
      const res = await axios(options);
      setSummaryDetails(res?.data?.data);
    } catch (e) {
    } finally {
      setLoading(false);
    }
  };
  for (const key in successGraph) {
    dates.push(convertDateFormat(key));
    successFetch.push(successGraph[key]);
  }
  for (const key in failedGraph) {
    failedDates.push(convertDateFormat(key));
    failedFetch.push(failedGraph[key]);
  }
  function convertDateFormat(dateString) {
    // Split the input string by space to separate the month and year
    const [month, year] = dateString.split(" ");

    // Extract the last two digits of the year
    const yearShort = year.slice(-2);

    // Return the formatted string
    return `${month},${yearShort}`;
  }

  useEffect(() => {
    if (agSubsection === "user") {
      fetchGraphDetails();
      fetchStatistics();
    }
    if (agSubsection === "consent") {
      fetchConsentDetails();
    }
    if (agSubsection === "summary") {
      fetchSummaryDetails();
    }
  }, [agSubsection]);

  const getImage = (key) => {
    switch (key) {
      case "anumati":
        return anumati;
      case "one_money":
        return oneMoney;
      case "finvu":
        return finvu;
      case "nadl":
        return nadl;

      case "cams_aa_finserv":
        return cams;
      case "protean":
        return protean;
      default:
        return anumati;
    }
  };
  return (
    <div className="flex flex-col space-y-3 px-[20px] text-[#212b36] bg-[#f1f1f6] pb-4">
      <div className=" bg-white h-24 px-4 flex flex-col justify-between pt-4">
        <p className=" text-xl font-semibold">Asset Gateway</p>
        <div className=" text-sm  space-x-8">
          {" "}
          {agFilter.map((item) => (
            <button
              className={` ] ${
                agSubsection === item.value
                  ? "border-b-[3px] border-[#212b36]  font-semibold"
                  : ""
              }   py-[10px]`}
              onClick={() => setAgSubsction(item.value)}
            >
              {item.name}
            </button>
          ))}
        </div>
      </div>
      {agSubsection === "user" && (
        <div className=" w-full h-[140px] rounded-lg bg-white">
          <div className=" mt-4 flex w-full justify-between px-4">
            <p className=" font-semibold text-base">Statistics</p>
          </div>
          <div className="  w-full h-[96px] px-4 flex justify-between ">
            <CardDetails
              name={"Total Users"}
              value={
                Statistics?.total_users !== null
                  ? Statistics?.total_users
                  : "NA"
              }
              image={totalUsers}
            />
            <CardDetails
              name={"Successful Request"}
              value={
                Statistics?.successful_fetch !== null
                  ? Statistics?.successful_fetch
                  : "NA"
              }
              Svg={SuccessfulRequest}
            />
            <CardDetails
              name={"Failed Requests"}
              value={
                Statistics?.failed_fetch !== null
                  ? Statistics?.failed_fetch
                  : "NA"
              }
              Svg={failedRequest}
            />
            <SlideImageCard />
          </div>
        </div>
      )}
      {agSubsection === "consent" && (
        <div className=" w-full  h-[140px] rounded-lg bg-white ">
          <div className=" min-w-[calc(100vw-300px)] overflow-x-auto">
            <div className=" mt-4 flex w-full justify-between px-4">
              <p className=" font-semibold text-base">Statistics</p>
            </div>
            <div className="   h-[96px] px-4 flex justify-between ">
              <CardDetails
                name={"Active Consent"}
                value={
                  consentStatistics.active_consents !== null
                    ? consentStatistics.active_consents
                    : "NA"
                }
                Svg={activeConsent}
              />
              <CardDetails
                name={"Expired Consent"}
                value={
                  consentStatistics?.expired_consents !== null
                    ? consentStatistics?.expired_consents
                    : "NA"
                }
                image={expired}
              />
              <CardDetails
                name={"Revoked Consent"}
                value={
                  consentStatistics.revoked_consents !== null
                    ? consentStatistics.revoked_consents
                    : "NA"
                }
                Svg={recvokedConsent}
              />
              <CardDetails
                name={"Rejected Consent"}
                value={
                  consentStatistics.rejected_consents !== null
                    ? consentStatistics.rejected_consents
                    : "NA"
                }
                image={cancel}
              />
              <CardDetails
                name={"Pending Request"}
                value={
                  consentStatistics.pending_consents !== null
                    ? consentStatistics.pending_consents
                    : "NA"
                }
                image={orderHistory}
              />
            </div>
          </div>
        </div>
      )}
      {agSubsection === "user" && (
        <div className=" flex justify-between">
          <div className=" w-[49.5%] h-[355px] bg-white rounded-lg">
            <SuccessfulRequestGraph
              type={"success"}
              dates={dates}
              fetch={successFetch}
              loading={Loading}
            />
          </div>
          <div className=" w-[49.5%] h-[355px] bg-white rounded-lg">
            {" "}
            <SuccessfulRequestGraph
              dates={dates}
              fetch={failedFetch}
              loading={Loading}
            />
          </div>
        </div>
      )}
      {agSubsection === "summary" && (
        <>
          <div className=" w-full p-4 bg-white  rounded-lg h-fit">
            {Loading && (
              <div className="w-full  flex justify-center items-center h-[calc(100vh-225px)]">
                <ImageLoading />
              </div>
            )}
            {!Loading && (
              <div className=" w-full flex flex-wrap justify-start gap-4 items-center ">
                {Object.keys(summaryDetails).map((key) => (
                  <AccountAggCard
                    image={getImage(key)}
                    active={
                      summaryDetails[key]?.active_consents !== null
                        ? summaryDetails[key]?.active_consents
                        : "--"
                    }
                    rejected={
                      summaryDetails[key]?.rejected_consents !== null
                        ? summaryDetails[key]?.rejected_consents
                        : "--"
                    }
                    expiredConsent={
                      summaryDetails[key]?.expired_consents !== null
                        ? summaryDetails[key]?.expired_consents
                        : "--"
                    }
                    pending={
                      summaryDetails[key]?.pending_consents !== null
                        ? summaryDetails[key]?.pending_consents
                        : "--"
                    }
                    revoked={
                      summaryDetails[key]?.revoked_consents !== null
                        ? summaryDetails[key]?.revoked_consents
                        : "--"
                    }
                    name={formatString(key)}
                  />
                ))}
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default AgSection;
